import { Form, Formik } from "formik"
import classes from "./AddAddress.module.scss"
import { useState } from "react";
import { addAddressValidation } from "../../../../../validations/ProfileValidations";
import { Checkbox, Input, Textarea } from "../../../../../components/Inputs/Input";
import { UserService } from "../../../../../services/UserService";
import { globalErrorHandler } from "../../../../../utils/errorHandler";
import { useLoader } from "../../../../../customHooks/loader";
import { toast } from "react-toastify";

export default function AddAddress({ setAddAddress, addAddress }) {
    console.log(addAddress)
    const loader = useLoader();
    const [initialValues, setInitialValues] = useState(
        addAddress?.id ? { ...addAddress } :
            {
                city: "",
                companyName: "",
                country: "",
                deliveryInstructions: "",
                firstName: "",
                lastName: "",
                phone: "",
                postalCode: "",
                isDefaultShippingAddress: false,
                isDefaultBillingAddress: false,
                state: "",
                streetAddress: ""
            }
    );
    const handleAddUserAddress = (values, resetForm) => {
        console.log({ values });
        UserService.addNewAddress(
            values,
            (data) => handleNewAddressSuccess(data, resetForm),
            globalErrorHandler,
            loader
        );
    }

    const handleNewAddressSuccess = ({ data }, resetForm) => {
        console.log(data)
        toast.success("New Address Added")
        resetForm();
        setAddAddress(false);
    }
    return (
        <div>
            <div className={classes.Heading}>Add Address</div>
            <div className={classes.BillingAddressContainer}>

                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    validationSchema={addAddressValidation}
                    onSubmit={(val, { resetForm }) => handleAddUserAddress(val, resetForm)}
                >
                    {({ errors, touched, values, isValidating, handleSubmit, ...props }) => (
                        <Form>
                            <div className={classes.InputRow}>
                                <Input
                                    type={'text'}
                                    name='firstName'
                                    placeholder='First Name'
                                    label='First Name'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                                <Input
                                    type={'text'}
                                    name='lastName'
                                    placeholder='Last Name'
                                    label='Last Name'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Input
                                    type={'text'}
                                    name='country'
                                    placeholder='Country / Region'
                                    label='Country / Region'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                                <Input
                                    type={'text'}
                                    name='companyName'
                                    placeholder='Company Name'
                                    label='Company Name'
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Input
                                    type={'text'}
                                    name='streetAddress'
                                    placeholder='House number and street name'
                                    label='Street Address'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                                <Input
                                    type={'text'}
                                    name='addressLine1'
                                    placeholder='apartment, suite, unit, etc. (optional)'
                                    label='Apt, suite, unit'
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Input
                                    type={'text'}
                                    name='city'
                                    placeholder='Town / City'
                                    label='City'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                                <Input
                                    type={'text'}
                                    name='state'
                                    placeholder='State'
                                    label='State'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Input
                                    type={'text'}
                                    name='postalCode'
                                    placeholder='Postal Code'
                                    label='Postal Code'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                                <Input
                                    type={'text'}
                                    name='phone'
                                    placeholder='Phone'
                                    label='Phone'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Input
                                    type='text'
                                    name='addressType'
                                    placeholder='Home, Office, Personal'
                                    label='Address Type'
                                    required
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.InputRow}>
                                <Textarea
                                    name='deliveryInstructions'
                                    placeholder='Delivery Instructions'
                                    label='Delivery Instructions'
                                    className={classes.AddressInput}
                                    labelClassName={classes.InputLabel}
                                />
                            </div>
                            <div className={classes.CheckboxInputRow}>
                                <Checkbox
                                    name='isDefaultShippingAddress'
                                    placeholder='Set as default shipping address'
                                    label='Set as default shipping address'
                                    labelClassName={classes.InputLabel}
                                />
                                <Checkbox
                                    name='isDefaultBillingAddress'
                                    placeholder='Set as default billing address'
                                    label='Set as default billing address'
                                    labelClassName={classes.InputLabel}
                                />
                            </div>

                            <div className={classes.Actions}>
                                <button type='submit' className={classes.AddAddressSubmitButton}>
                                    Save
                                </button>
                                <button
                                    onClick={() => {
                                        props.resetForm();
                                        setAddAddress(false);
                                    }}
                                    className={classes.Cancel}
                                >
                                    Cancel
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}
